import './PeriscopeTitle.scss';
import { ActiveIndicator } from '@ui/icons';
import { FlexFiller } from '@ui/FlexFiller';
import { FollowButton } from './FollowButton';
import { getSonarObjectTypeSourceLabel } from '@sonar-software/sonar-ts-lib';
import { isEmpty } from 'lodash';
import { PeriscopeInitiatives } from './PeriscopeInitiatives';
import { Space } from 'antd';
import Tooltip from 'antd/es/tooltip';
import { useCurrentUser } from '@hooks';
import { VersionNumber } from '@ui/VersionNumber';
import { When } from 'react-if';
import { COPY_SPECIFIC, ORGANIZATION_TYPE_LABELS } from '@sonar-software/sonar-ts-constants';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useMemo } from 'react';
function showAddToInitiatives(type, isReadOnly) {
    const source = getSonarObjectTypeSourceLabel(type);
    return source !== ORGANIZATION_TYPE_LABELS.SONAR && !isReadOnly;
}
export const PeriscopeTitle = ({ data }) => {
    const { isReadOnly } = useCurrentUser();
    const { internalName, displayName, isActive, sonarObjectId, sonarObjectType, versionNumber } = data;
    const showInitiatives = useMemo(() => showAddToInitiatives(sonarObjectType, isReadOnly), [isReadOnly, sonarObjectType]);
    return (React.createElement("div", { className: 'periscope-title' },
        React.createElement("div", { className: 'periscope-title-name' },
            React.createElement(Tooltip, { open: isEmpty(internalName) ? false : undefined, placement: 'bottom', title: `${COPY_SPECIFIC.API_NAME}: ${internalName}` },
                React.createElement("span", null, displayName)),
            React.createElement(VersionNumber, { number: versionNumber })),
        React.createElement(ActiveIndicator, { isActive: isActive }),
        React.createElement(FlexFiller, null),
        React.createElement(Space, null,
            React.createElement(When, { condition: showInitiatives },
                React.createElement(PeriscopeInitiatives, { sonarObjectId: sonarObjectId })),
            React.createElement(When, { condition: sonarObjectType !== SonarObjectType.SalesforceReport },
                React.createElement(FollowButton, { sonarObjectIds: [sonarObjectId] })))));
};
